import { createAction } from 'typesafe-actions';

export const changeFloorMinAction = createAction('filters/minFloorChanged')<number>();
